import * as AuthService from '@/services/api/auth'

// type State = {
//   token?: any  
// }

const state = {}

const getters = {
  getToken: (state) => {
    return state.token
  },
}

const mutations = {
   updateToken: (state, payload) => {
     console.log(payload)
    state.token = payload
  },  
}

const actions = {
  async generateToken({ commit}) {
    console.log(98889)
    const response = await AuthService.getToken() 
    // console.log(response)
    if (response.status === 200) {
      // console.log(response.data)
      commit('updateToken', response.data)
    }
    
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
}
